import React from "react";
import PublicSiteShell from "./PublicSiteShell";

export default function PublicContentPageShell({
  topBandTone = "hero",
  ...props
}) {
  return <PublicSiteShell topBandTone={topBandTone} {...props} />;
}
